import { clientApp } from './index';

export const getPaymentMethods = () => clientApp.get(`/ui/xeniapos/paymentmethods`);
export const getGroupsUpper = () => clientApp.get(`/ui/xeniapos/uppergroup`);
export const getGroupsMain = () => clientApp.get(`/ui/xeniapos/mainGroup`);
export const getGroups = () => clientApp.get(`/ui/xeniapos/group`);
export const importEntries = (from: string, to: string) => clientApp.get(`/ui/xeniapos/import/date/${from}/${to}`);
